import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "notificationText" }
const _hoisted_2 = { class: "footer" }
const _hoisted_3 = { class: "footer-actions" }
const _hoisted_4 = { class: "row" }

import Icon from "@common/components/Icon.vue";
import { computed, reactive } from "vue";
import { useI18n } from "vue-i18n";

type ViewModel = {
  dontShowMessageAgain: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationModal',
  props: {
    showModal: { type: Boolean }
  },
  emits: ["update:showModal", "notificationStatus"],
  setup(__props: any, { emit }) {

const props = __props;


const { t: $t } = useI18n();


const viewModel = reactive<ViewModel>({
  dontShowMessageAgain: false
});

const _showModal = computed({
  get: () => {
    return props.showModal;
  },
  set: (nv) => {
    emit("update:showModal", nv);
  }
});

const sendNotificationStatus = () => {
  emit("notificationStatus", viewModel.dontShowMessageAgain);
};

return (_ctx: any,_cache: any) => {
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_checkbox = _resolveComponent("b-checkbox")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_b_btn = _resolveComponent("b-btn")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    title: _unref($t)('AiTexter.LegalInformationTitle'),
    class: "legal-information-modal-container",
    "header-close-content": "",
    "body-class": "legal-information-modal",
    modelValue: _showModal.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_showModal).value = $event)),
    centered: "",
    "no-close-on-backdrop": ""
  }, {
    "modal-footer": _withCtx(({ cancel }) => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_b_btn, {
              variant: "primary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (sendNotificationStatus())),
              "data-cy": "ai-texter-legal-information-accept-button"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref($t)("AiTexter.Ok")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_b_btn, { onClick: cancel }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref($t)("AiTexter.Cancel")), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_b_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_b_col, {
            cols: "2",
            class: "d-flex justify-content-center align-items-center"
          }, {
            default: _withCtx(() => [
              _createVNode(Icon, {
                icon: "WatcherWarning",
                style: {"font-size":"3rem"}
              })
            ]),
            _: 1
          }),
          _createVNode(_component_b_col, { cols: "10" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, _toDisplayString(_unref($t)("AiTexter.LegalInformationNotification")), 1),
              _createVNode(_component_b_checkbox, {
                style: {"margin-top":"12px"},
                modelValue: viewModel.dontShowMessageAgain,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((viewModel.dontShowMessageAgain) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref($t)("AiTexter.DontShowMessage")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}
}

})